<template>
  <div>
    <ViewMilageCase></ViewMilageCase>
  </div>
</template>
  
  <script>
const ViewMilageCase = defineAsyncComponent(() =>
  import("@/components/cases/ViewMileageCase")
);
import { defineAsyncComponent } from "vue";
export default {
  components: {
    ViewMilageCase,
  },
};
</script>
